import React from 'react'
import { HamburgerIcon } from '../icons/HamburgerIcon'
import { SidebarLeftIcon } from '../icons/SidebarLeftIcon'
import { SidebarLeftCollapsedIcon } from '../icons/SidebarLeftCollapsedIcon'

const ICON_SIZE = 16

interface SidebarToggleProps {
  variant: 'hamburger' | 'sidebar-icon'
  isOpen: boolean
  onClick: () => void
  label: string
}

export const SidebarToggle = React.memo(({ variant, isOpen, onClick, label }: SidebarToggleProps) => (
  <button
    className={`titlebar__sidebar-toggle titlebar__sidebar-toggle--${variant}`}
    onClick={onClick}
    aria-label={label}
  >
    {variant === 'hamburger'
      ? <HamburgerIcon size={ICON_SIZE} />
      : isOpen ? <SidebarLeftIcon size={ICON_SIZE} /> : <SidebarLeftCollapsedIcon size={ICON_SIZE} />
    }
  </button>
))
